import ApisService from './index'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'


export function getDetailHeThong(id: string) {
  try {
    return ApisService.get('/hethong/' + id + '/get-chitiet-hethong')
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function getListHeThong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/hethong/filter-hethong', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}


export function changeHeThong(projectId: number) {
  return ApisService.put('/hethong/' + projectId + '/doi-hethong')
} 